import React, { useState, useEffect } from 'react';
import Navigation from './Navigation';

const Header = ({ activeTab, setActiveTab, isAdmin }) => {
    // Состояние для отслеживания прокрутки
    const [isScrolled, setIsScrolled] = useState(false);

    // Обработчик прокрутки страницы
    useEffect(() => {
        const handleScroll = () => {
            // Если прокручено более 20px, считаем что страница прокручена
            if (window.scrollY > 20) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        // Добавляем обработчик события прокрутки
        window.addEventListener('scroll', handleScroll);

        // Удаляем обработчик при размонтировании компонента
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="header-content">
                    <div className="logo" onClick={() => setActiveTab('home')}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="#1e3a8a"
                            stroke="none"
                        >
                            <path d="M22.5,10.5L20,8l-2-5H6L4,8L1.5,10.5L1,12v6.5C1,19.33,1.67,20,2.5,20h1C4.33,20,5,19.33,5,18.5V17h14v1.5
                                c0,0.83,0.67,1.5,1.5,1.5h1c0.83,0,1.5-0.67,1.5-1.5V12L22.5,10.5z M4.8,8.5L6,5h12l1.2,3.5H4.8z M5,15.5c-0.83,0-1.5-0.67-1.5-1.5
                                s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S5.83,15.5,5,15.5z M19,15.5c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5
                                S19.83,15.5,19,15.5z"/>
                        </svg>
                        <span>СФЕРА АВТО</span>
                    </div>

                    {/* Навигация - теперь всегда видна на всех устройствах */}
                    <Navigation
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        isAdmin={isAdmin}
                    />
                </div>
            </div>
        </header>
    );
};

export default Header;
